var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, "max-width": "610", persistent: "" } },
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            top: "",
            "content-class": "pa-0",
            color: "warning",
            timeout: -1
          },
          model: {
            value: _vm.perishablesAlert,
            callback: function($$v) {
              _vm.perishablesAlert = $$v
            },
            expression: "perishablesAlert"
          }
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "my-0",
              attrs: {
                dense: "",
                border: "left",
                prominent: "",
                type: "warning",
                "retain-focus": true
              },
              model: {
                value: _vm.perishablesAlert,
                callback: function($$v) {
                  _vm.perishablesAlert = $$v
                },
                expression: "perishablesAlert"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.perishablesAlertMessage) + " "),
              _c("br"),
              _c(
                "span",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-4 mr-4",
                      attrs: { outlined: "", loading: _vm.saving },
                      on: { click: _vm.submitPerishablesWithWarning }
                    },
                    [_vm._v(" Continue ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-4",
                      on: {
                        click: function($event) {
                          _vm.perishablesAlert = false
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            top: "",
            "content-class": "pa-0",
            color: "warning",
            timeout: -1
          },
          model: {
            value: _vm.lateSubmissionAlert,
            callback: function($$v) {
              _vm.lateSubmissionAlert = $$v
            },
            expression: "lateSubmissionAlert"
          }
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "my-0",
              attrs: {
                dense: "",
                border: "left",
                prominent: "",
                type: "warning",
                "retain-focus": true
              },
              model: {
                value: _vm.lateSubmissionAlert,
                callback: function($$v) {
                  _vm.lateSubmissionAlert = $$v
                },
                expression: "lateSubmissionAlert"
              }
            },
            [
              _c("div", { staticClass: "mb-1" }, [
                _vm._v(" " + _vm._s(_vm.lateSubmissionMessage) + " ")
              ]),
              _c("br"),
              _vm._v(" Continue to submit promotion? "),
              _c(
                "span",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-4",
                      attrs: { outlined: "", loading: _vm.saving },
                      on: { click: _vm.submitLateSubmission }
                    },
                    [_vm._v(" Yes ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          _vm.lateSubmissionAlert = false
                        }
                      }
                    },
                    [_vm._v(" No ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm.misalignedPartySourceAlert
        ? _c(
            "v-snackbar",
            {
              attrs: {
                top: "",
                "content-class": "pt-0 pb-0 pl-0",
                color: "error",
                timeout: -1
              },
              model: {
                value: _vm.misalignedPartySourceAlert,
                callback: function($$v) {
                  _vm.misalignedPartySourceAlert = $$v
                },
                expression: "misalignedPartySourceAlert"
              }
            },
            [
              _c(
                "v-alert",
                {
                  staticClass: "pr-4",
                  attrs: {
                    border: "left",
                    prominent: "",
                    type: "error",
                    "retain-focus": true
                  },
                  model: {
                    value: _vm.misalignedPartySourceAlert,
                    callback: function($$v) {
                      _vm.misalignedPartySourceAlert = $$v
                    },
                    expression: "misalignedPartySourceAlert"
                  }
                },
                [
                  _vm.missingSourceError
                    ? _c("div", [
                        _c(
                          "p",
                          { staticStyle: { "word-break": "break-word" } },
                          [_vm._v(" " + _vm._s(_vm.missingSourceError) + " ")]
                        ),
                        _c("p", [
                          _vm._v(
                            "Please add the items if available, or delete the below groups/stores if there are no items available in the division(s):"
                          )
                        ]),
                        _c(
                          "p",
                          { staticStyle: { "word-break": "break-word" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  "" + _vm.missingSourceParties.join(", ")
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.invalidSourceError
                    ? _c("div", [
                        _vm._v(" " + _vm._s(_vm.invalidSourceError) + " ")
                      ])
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-4 mr-4",
                      attrs: { outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(" Acknowledge ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v("Update Promotion Status "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.cancelDisabled,
                    text: "",
                    color: "grey darken-2"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    loading: _vm.saving || _vm.loadingItems,
                    disabled: _vm.changesDisabled,
                    color: "primary"
                  },
                  on: { click: _vm.saveStatus }
                },
                [_vm._v(" Save ")]
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "mb-0 pb-0 px-4" },
            [
              _c(
                "v-container",
                { staticClass: "mt-0 pt-0" },
                [
                  _c(
                    "v-row",
                    [
                      _vm.promoStatus
                        ? _c(
                            "v-col",
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Status",
                                  "menu-props": { offsetY: true },
                                  items: _vm.validStatuses,
                                  "item-text": "name",
                                  "item-color": "action",
                                  "return-object": "",
                                  "hide-details": "auto",
                                  disabled: _vm.changesDisabled,
                                  outlined: "",
                                  dense: ""
                                },
                                model: {
                                  value: _vm.promoStatus.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.promoStatus, "status", $$v)
                                  },
                                  expression: "promoStatus.status"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-textarea", {
                            attrs: {
                              label: "Notes",
                              disabled: _vm.changesDisabled,
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.promoStatus.notes,
                              callback: function($$v) {
                                _vm.$set(_vm.promoStatus, "notes", $$v)
                              },
                              expression: "promoStatus.notes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("StatusHistory", { attrs: { promo: _vm.promo } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.promoConflictAlert
        ? _c("PromoConflictModal", {
            attrs: {
              duplicatePromos: _vm.duplicatePromos,
              overlappingPromos: _vm.overlappingPromos
            },
            on: {
              close: _vm.closeModals,
              submitWithOverlap: _vm.submitWithOverlap
            },
            model: {
              value: _vm.promoConflictAlert,
              callback: function($$v) {
                _vm.promoConflictAlert = $$v
              },
              expression: "promoConflictAlert"
            }
          })
        : _vm._e(),
      _vm.dsdValidationAlert
        ? _c("DsdValidationModal", {
            attrs: { message: _vm.dsdValidationMessage },
            on: { close: _vm.closeModals },
            model: {
              value: _vm.dsdValidationAlert,
              callback: function($$v) {
                _vm.dsdValidationAlert = $$v
              },
              expression: "dsdValidationAlert"
            }
          })
        : _vm._e(),
      _vm.adFeeAlert
        ? _c("AdFeeAlertModal", {
            attrs: { promo: _vm.promo, allowContinue: _vm.allowAdFeeContinue },
            on: {
              close: _vm.closeModals,
              submitWithAdFeeAlert: _vm.submitWithAdFeeAlert
            },
            model: {
              value: _vm.adFeeAlert,
              callback: function($$v) {
                _vm.adFeeAlert = $$v
              },
              expression: "adFeeAlert"
            }
          })
        : _vm._e(),
      _vm.netUnitAllowanceAlert
        ? _c("NetUnitAllowanceAlertModal", {
            attrs: { promoItems: _vm.netUnitAllowanceViolations },
            on: {
              close: _vm.closeModals,
              submitWithNetUnitAllowanceAlert:
                _vm.submitWithNetUnitAllowanceAlert
            },
            model: {
              value: _vm.netUnitAllowanceAlert,
              callback: function($$v) {
                _vm.netUnitAllowanceAlert = $$v
              },
              expression: "netUnitAllowanceAlert"
            }
          })
        : _vm._e(),
      _vm.missingLinkedItemsAlert
        ? _c("MissingLinkedItemsAlertModal", {
            attrs: { missingItems: _vm.missingLinkedItems },
            on: {
              close: _vm.closeModals,
              submitWithMissingLinkedItemsAlert:
                _vm.submitWithMissingLinkedItemsAlert
            },
            model: {
              value: _vm.missingLinkedItemsAlert,
              callback: function($$v) {
                _vm.missingLinkedItemsAlert = $$v
              },
              expression: "missingLinkedItemsAlert"
            }
          })
        : _vm._e(),
      _vm.shortTPRAlert
        ? _c("ShortTPRAlertModal", {
            on: {
              close: _vm.closeModals,
              submitWithShortTPRAlert: _vm.submitWithShortTPRAlert
            },
            model: {
              value: _vm.shortTPRAlert,
              callback: function($$v) {
                _vm.shortTPRAlert = $$v
              },
              expression: "shortTPRAlert"
            }
          })
        : _vm._e(),
      _vm.tprAlignmentAlert
        ? _c("TPRAlignmentAlertModal", {
            attrs: { misalignedPromos: _vm.misalignedPromos, promo: _vm.promo },
            on: {
              close: _vm.closeModals,
              submitMisalignedTPR: _vm.submitMisalignedTPR
            },
            model: {
              value: _vm.tprAlignmentAlert,
              callback: function($$v) {
                _vm.tprAlignmentAlert = $$v
              },
              expression: "tprAlignmentAlert"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }